(function () {
  // Song page (/pages/song?id=<song id>): the link Wet Studio's "Share link" copies.
  // One posted song with a big player, who made it (linked to their profile),
  // more of their songs, and a way into Wet Studio. Only songs their owner
  // posted are readable (the wetstudio_public_tracks view), so a private or
  // removed song shows "not available".
  // Design: the site's green on deep, square corners, Anton headings.

  function esc(v) {
    if (v === null || v === undefined) return '';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmt(secs) { if (!isFinite(secs) || secs < 0) secs = 0; var s = Math.round(secs); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function displayName(p) { return p.display_name || p.username; }
  function profileUrl(p) { return window.ReigningWet.getProfileUrl ? window.ReigningWet.getProfileUrl(p.username) : '/pages/profile?u=' + encodeURIComponent(p.username); }
  function initials(p) {
    var w = displayName(p).split(/[\s._-]+/).filter(function (x) { return /[A-Za-z0-9]/.test(x); });
    return ((w.length > 1 ? w[0].charAt(0) + w[1].charAt(0) : (w[0] || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 2)) || '?').toUpperCase();
  }
  function avatar(p) {
    return typeof p.avatar_url === 'string' && /^https:\/\//i.test(p.avatar_url)
      ? '<span class="rs-av" style="background-image:url(' + esc(p.avatar_url) + ')"></span>'
      : '<span class="rs-av">' + esc(initials(p)) + '</span>';
  }
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>';
  var LINK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg>';

  var sb, el, song = null, artist = null, more = [], playing = null, audio = null;

  function publicUrl(path) { return sb.storage.from('wetstudio-public').getPublicUrl(path).data.publicUrl; }
  function load(id) {
    return sb.from('wetstudio_public_tracks').select('id, profile_id, name, bpm, key_label, duration, preview_path, published_at').eq('id', id).maybeSingle().then(function (r) {
      if (r.error) throw r.error;
      if (!r.data) return null;
      song = r.data; song.url = publicUrl(song.preview_path);
      return Promise.all([
        sb.from('profiles').select('id, username, display_name, avatar_url, is_banned').eq('id', song.profile_id).maybeSingle(),
        sb.from('wetstudio_public_tracks').select('id, name, bpm, key_label, duration, preview_path, published_at').eq('profile_id', song.profile_id).neq('id', song.id).order('published_at', { ascending: false }).limit(5)
      ]).then(function (x) {
        artist = x[0].data && !x[0].data.is_banned ? x[0].data : null;
        if (!artist) return null;
        more = (x[1].data || []).map(function (t) { t.url = publicUrl(t.preview_path); return t; });
        return song;
      });
    });
  }

  function render() {
    var meta = [song.bpm ? song.bpm + ' BPM' : '', song.key_label || '', song.duration ? fmt(song.duration) : ''].filter(Boolean);
    var h = ['<main class="rs">'];
    h.push('<p class="rs-eyebrow">Made in Wet Studio</p><h1 class="rs-title">' + esc(song.name || 'Untitled') + '</h1>');
    h.push('<a class="rs-artist" href="' + esc(profileUrl(artist)) + '">' + avatar(artist) + '<span>' + esc(displayName(artist)) + '</span></a>');
    h.push('<div class="rs-player"><button class="rs-play" data-act="play" data-i="-1" aria-label="Play">' + (playing === -1 ? PAUSE : PLAY) + '</button>' +
      '<div class="rs-bar"><div class="rs-track" data-act="seek" role="slider" aria-label="Seek" tabindex="0"><i id="rs-fill"></i></div>' +
      '<div class="rs-times"><span id="rs-cur">0:00</span><span>' + (song.duration ? fmt(song.duration) : '') + '</span></div></div></div>');
    h.push('<div class="rs-row"><span class="rs-meta">' + esc(meta.join(' · ')) + '</span><button class="rs-btn is-ghost" data-act="share">' + LINK + ' <span id="rs-share">Share</span></button></div>');
    if (more.length) {
      h.push('<h2 class="rs-h2">More from ' + esc(displayName(artist)) + '</h2><div class="rs-list">');
      more.forEach(function (t, i) {
        h.push('<div class="rs-item"><button class="rs-mini" data-act="play" data-i="' + i + '" aria-label="Play ' + esc(t.name) + '">' + (playing === i ? PAUSE : PLAY) + '</button>' +
          '<a class="rs-iname" href="?id=' + esc(t.id) + '">' + esc(t.name || 'Untitled') + '</a><span class="rs-meta">' + esc([t.bpm ? t.bpm + ' BPM' : '', t.duration ? fmt(t.duration) : ''].filter(Boolean).join(' · ')) + '</span></div>');
      });
      h.push('</div><a class="rs-more" href="' + esc(profileUrl(artist)) + '">See their profile →</a>');
    }
    h.push('<section class="rs-cta"><p class="rs-eyebrow">Wet Studio</p><h2>Make beats like this. Free.</h2><p>A full studio in your browser: laptop, phone or tablet. Nothing to install.</p><a class="rs-btn" href="/pages/wet-studio">Open Wet Studio</a></section>');
    h.push('</main>');
    el.innerHTML = h.join('');
  }
  function renderState(title, line) {
    el.innerHTML = '<main class="rs rs-center"><p class="rs-eyebrow">song</p><h1 class="rs-title">' + esc(title) + '</h1><p class="rs-meta">' + esc(line) + '</p><a class="rs-btn" href="/pages/wet-studio">Open Wet Studio</a></main>';
  }

  function toggle(i) {
    var t = i === -1 ? song : more[i]; if (!t) return;
    if (!audio) {
      audio = new Audio(); audio.preload = 'none';
      audio.addEventListener('ended', function () { playing = null; paint(); });
      audio.addEventListener('timeupdate', function () {
        if (playing !== -1) return;
        var f = document.getElementById('rs-fill'), c = document.getElementById('rs-cur');
        if (f && audio.duration) f.style.transform = 'scaleX(' + (audio.currentTime / audio.duration) + ')';
        if (c) c.textContent = fmt(audio.currentTime);
      });
    }
    if (playing === i) { audio.pause(); playing = null; paint(); return; }
    if (audio.src !== t.url) audio.src = t.url;
    audio.play().catch(function () {});
    playing = i; paint();
  }
  function paint() {   // just the play buttons, so the progress bar keeps its place
    Array.prototype.forEach.call(el.querySelectorAll('[data-act=play]'), function (b) { b.innerHTML = +b.dataset.i === playing ? PAUSE : PLAY; b.setAttribute('aria-label', +b.dataset.i === playing ? 'Pause' : 'Play'); });
  }
  function share() {
    var url = location.origin + location.pathname + '?id=' + encodeURIComponent(song.id), lbl = document.getElementById('rs-share');
    var done = function (txt) { if (lbl) { lbl.textContent = txt; setTimeout(function () { lbl.textContent = 'Share'; }, 1800); } };
    if (navigator.share && window.matchMedia && matchMedia('(pointer: coarse)').matches) { navigator.share({ title: song.name, text: song.name + ' by ' + displayName(artist), url: url }).catch(function () {}); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done('Link copied'); }, function () { window.prompt('Copy this link', url); });
    else window.prompt('Copy this link', url);
  }
  function onClick(e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var a = b.dataset.act;
    if (a === 'play') toggle(+b.dataset.i);
    else if (a === 'share') share();
    else if (a === 'seek') {
      if (playing !== -1) toggle(-1);
      var go = function () { var r = b.getBoundingClientRect(); audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration; };
      if (audio && audio.duration) go(); else if (audio) audio.addEventListener('loadedmetadata', go, { once: true });
    }
  }

  function boot() {
    el = document.getElementById('rw-song-page'); if (!el) return;
    var id = (new URLSearchParams(location.search).get('id') || '').trim();
    if (!/^[0-9a-f-]{36}$/i.test(id)) return renderState('Song not found', 'This link is missing its song. Ask whoever sent it for the full link.');
    el.addEventListener('click', onClick);
    function go() {
      sb = window.ReigningWet.supabase;
      load(id).then(function (s) {
        if (!s) return renderState('Not available', 'This song is private or was taken down.');
        document.title = (song.name || 'Untitled') + ' by ' + displayName(artist) + ' – Reigning Wet';
        render();
      }).catch(function (err) {
        if (window.console) console.error('[ReigningWet] Failed to load song:', err);
        renderState('Couldn’t load', 'Try again in a moment.');
      });
    }
    if (window.ReigningWet && window.ReigningWet.supabase) go();
    else {
      document.addEventListener('reigningwet:supabase-ready', go, { once: true });
      document.addEventListener('reigningwet:supabase-error', function () { renderState('Couldn’t load', 'Try again in a moment.'); }, { once: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();